import React from 'react';
import { InView } from 'react-intersection-observer';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _cloneDeep from 'lodash/cloneDeep';
import _functions from 'lodash/functions';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _omit from 'lodash/omit';
import _pick from 'lodash/pick';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';

import JobBucketAlerts from 'components/callouts/jobBucketAlerts';
import { Swipe } from 'components/Swipe';
import ZpButton from 'components/zpButton';
import { updateUserRating } from 'services/userService';
import {
  dispatchGetCompanyJobs,
  dispatchGetCompanyJobsMore,
  dispatchUserJobs,
  dispatchUserJobsMore,
  getPaidJobs,
} from 'store/jobs/actions';
import {
  dispatchSessionBucketScrollSignupModal,
  dispatchSessionShowMoreSignupModal,
  showJobAlertPopup,
} from 'store/modals/actions';
import { STATE_HISTORY_OPERATIONS } from 'store/searchFilter';
import { updateFiltersState } from 'store/searchFilter/actions';
import {
  EVENTS,
  formatNumber,
  getNumPaidJobs,
  getStateAbbr,
  getStateName,
  isValidExtendedLocation,
  JOB_BUCKET_GROUP,
  openInCurrentTab,
  paginatePaidJobs,
  serializetoQuery,
} from 'utils';
import { logCustomGTMEvent } from 'utils/analyticsGTM';

import CompanyJobAlerts from '../../callouts/companyJobAlerts/companyJobAlerts';
import FilterCarousel from '../../zpFilter/FilterCarousel';
import {
  addRemoteFilterToPaidJobs,
  filterSearchKey,
  getInitialFilters,
  isQueryParams,
  mapFilterSearchParams,
  mapFilterValues,
  mapPaidJobFilters,
  validatePaidJobsPayload,
} from '../../zpFilter/filterUtils';
import JobCard from '../card';
import ShareZippiaJobCard from '../card/ShareZippiaJobCard';
import JobCardLoader from '../loader';
import NoJob from '../noJob';

import jobContainerClasses from './index.module.css';
import bucketClasses from 'css/jobBuckets.module.css';

/**
 * There are two way to render jobCard
 * 1. In Container in Horizontal (bucketView)
 * 2. In Carousal in  Vertical (netflixView)
 */
const layoutType = Object.freeze({
  bucket: 'bucket',
  netflix: 'netflix',
});

const CARD_WIDTH = 264;
const JOBS_PER_SLIDE = 4;

class JobContainer extends React.Component {
  static propTypes = {
    dispatchGetCompanyJobs: PropTypes.func.isRequired,
    dispatchUserJobs: PropTypes.func.isRequired,
    dispatchGetCompanyJobsMore: PropTypes.func.isRequired,
    dispatchUserJobsMore: PropTypes.func.isRequired,
    dispatchSessionBucketScrollSignupModal: PropTypes.func.isRequired,
    dispatchSessionShowMoreSignupModal: PropTypes.func.isRequired,
    filterCallback: PropTypes.func,
    // should get user listing when job container displayed
    // default is true
    getUserListings: PropTypes.bool,
    // title of the job container
    title: PropTypes.string,
    isH3Title: PropTypes.bool,
    errorMessage: PropTypes.string,
    jobs: PropTypes.arrayOf(
      PropTypes.shape({
        listingHash: PropTypes.string,
        jobId: PropTypes.string,
      })
    ),
    totalJobs: PropTypes.number,
    countOfH2Cards: PropTypes.number,
    loading: PropTypes.bool,
    error: PropTypes.any,
    filterGroup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    layout: PropTypes.oneOf(['bucket', 'netflix']).isRequired,
    jobType: PropTypes.oneOf(['user', 'company']),
    // pass the key of jobs state reducers
    jobGroup: PropTypes.string,
    initialPayload: PropTypes.shape({}),
    bucketContainerClass: PropTypes.string,
    headerClass: PropTypes.string,
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        city: PropTypes.string,
        state: PropTypes.string,
      })
    ),
    filters: PropTypes.arrayOf(PropTypes.object),
    userLocation: PropTypes.arrayOf(
      PropTypes.shape({
        city: PropTypes.string,
        state: PropTypes.string,
      })
    ),
    criteria: PropTypes.object,
    fetchJobsOnMount: PropTypes.bool,
    updatePreference: PropTypes.bool,
    resetPreference: PropTypes.bool,
    swapFilters: PropTypes.bool,
    emptyBuckets: PropTypes.bool,
    isHidden: PropTypes.bool,
    jobsPerPage: PropTypes.number,
    displaySeeMore: PropTypes.string,
    isCityPage: PropTypes.bool,
    isRemote: PropTypes.bool,
    jobsPage: PropTypes.bool,
    noCMPPage: PropTypes.bool,
    loadWithRemote: PropTypes.bool,
    isCppRemote: PropTypes.bool,
    followerJobGroup: PropTypes.string,
    isVisited: PropTypes.bool,
    ignoreDismissed: PropTypes.bool,
    isFollower: PropTypes.bool,
    disableDismiss: PropTypes.bool,
    customJobCard: PropTypes.node,
    isDesktop: PropTypes.bool,
    expiredJobOnExternal: PropTypes.bool,
    singleCompactFilter: PropTypes.bool,
    logJobCardClickEvent: PropTypes.func,
    jobsDescription: PropTypes.string,
    withCreateAlert: PropTypes.bool,
    enablePaidFixedPos: PropTypes.bool,
    paidJobAPIPayload: PropTypes.object,
    customTitleTag: PropTypes.object,
    afterEveryX: PropTypes.number,
    paidJobGroup: PropTypes.string,
    hideMoreBtn: PropTypes.bool,
    useOnlyPaidJobs: PropTypes.bool,
    onShowMoreJobs: PropTypes.func,
    noBottomSpacing: PropTypes.bool,
    jobsPerSlide: PropTypes.number,
  };

  static defaultProps = {
    errorMessage: 'Aw snap, no jobs found',
    totalJobs: 0,
    loading: false,
    title: 'A Recommended For You',
    isH3Title: false,
    error: null,
    getUserListings: true,
    filterGroup: null,
    jobGroup: null,
    jobs: [],
    filters: [],
    initialPayload: {},
    bucketContainerClass: '',
    headerClass: '',
    locations: [],
    fetchJobsOnMount: false,
    updatePreference: false,
    jobType: 'company',
    swapFilters: false,
    resetPreference: true,
    emptyBuckets: false,
    isHidden: false,
    jobsPerPage: 20,
    countOfH2Cards: 0,
    displaySeeMore: null,
    isCityPage: false,
    isRemote: false,
    loadWithRemote: false,
    isCppRemote: false,
    isVisited: false,
    ignoreDismissed: false,
    isFollower: false,
    disableDismiss: false,
    isDesktop: undefined,
    expiredJobOnExternal: false,
    singleCompactFilter: false,
    logJobCardClickEvent: () => {},
    jobsDescription: '',
    withCreateAlert: false,
    enablePaidFixedPos: false,
    paidJobAPIPayload: {},
    customTitleTag: {},
    afterEveryX: 0,
    paidJobGroup: JOB_BUCKET_GROUP.PAID_JOBS,
    hideMoreBtn: true,
    useOnlyPaidJobs: false,
    noBottomSpacing: false,
    jobsPerSlide: JOBS_PER_SLIDE,
  };

  constructor(props) {
    super(props);
    this.bucketListRef = React.createRef();
    this.scrollLeftToFireGTMScrollEvent = 0;
    this.state = {
      showNext: false,
      showPrev: false,
      visited: props.isVisited,
      showLoading: false,
      initialPayload: _cloneDeep(props.initialPayload),
      showAllQuery: serializetoQuery(props.initialPayload),
      showNoJobs: false,
      zpFilters: getInitialFilters(
        props.filters,
        props.criteria,
        this.getUserLocations(),
        props?.router?.query
      ),
      showRemote: props.initialPayload.remote,
      loadWithRemote: props.loadWithRemote,
      jobSearched: props.initialPayload.jobTitle,
      userListingHashesFetched: false,
      bucketScroll: 0,
    };
  }

  componentDidMount() {
    document.addEventListener('updateOtherFilterGroup', this.updateFilterOnChangeOfExternalFilter);
  }

  componentDidUpdate(prevProps) {
    const {
      loading,
      jobs,
      filters,
      filterGroup,
      initialPayload,
      filterQueue,
      filterQueueLength,
      dismissedCount,
      totalJobs,
    } = this.props;

    const { userListingHashesFetched } = this.state;

    if (prevProps.loading && loading === false) {
      this.setState({ showNoJobs: true });
    }
    if (initialPayload !== prevProps.initialPayload) {
      this.setState({ initialPayload });
    }

    if (
      prevProps.filterQueueLength !== filterQueueLength &&
      filterQueueLength > 0 &&
      userListingHashesFetched &&
      filterGroup
    ) {
      this.handleFilterApply(
        mapFilterValues(filterQueue[filterQueueLength - 1]),
        false,
        filterQueue[filterQueueLength - 1]
      );
    }

    if (!_isEqual(prevProps.filters, filters)) {
      const filtersWithoutFunctions = filters.map((f) => _omit(f, _functions(f)));
      const prevFiltersWithoutFunctions = prevProps.filters.map((f) => _omit(f, _functions(f)));
      if (!_isEqual(filtersWithoutFunctions, prevFiltersWithoutFunctions)) {
        this.setState({
          zpFilters: filters,
        });
      }
    }

    if (dismissedCount === jobs.length && totalJobs !== 0 && !loading) {
      this.getMoreJobs();
    }

    this.checkForNextArrow();
  }

  componentWillUnmount() {
    document.removeEventListener(
      'updateOtherFilterGroup',
      this.updateFilterOnChangeOfExternalFilter
    );
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  checkForNextArrow = () => {
    const { layout, jobsPerSlide } = this.props;
    const { bucketScroll, showNext } = this.state;
    const { children: list = [] } = this.bucketListRef?.current || {};

    if (
      layout === layoutType.bucket &&
      showNext === false &&
      bucketScroll === 0 &&
      (list.length > jobsPerSlide || !this.hasNoMoreJobs())
    ) {
      this.setState({ showNext: true });
    }
  }

  hasNoMoreJobs = () => {
    const { jobsPerPage, jobs, totalJobs } = this.props;

    return totalJobs === 0 || (jobs.length <= jobsPerPage && totalJobs <= jobsPerPage);
  };

  getNewFiltersOnFilterSearchParams = (filterSearchParams) => {
    const zpFilters = [...this.state.zpFilters];
    if (filterSearchParams && !_isEmpty(filterSearchParams)) {
      Object.keys(filterSearchParams).forEach((param) => {
        if (filterSearchParams[param]) {
          const index = zpFilters.findIndex((filter) => filter.param === param);
          if (index !== -1) {
            zpFilters[index].preselectedItems = [...filterSearchParams[param]];

            const values = zpFilters[index].preselectedItems;

            zpFilters[index].newButtonText =
              values.length > 1
                ? `${values[0].displayName}, ...`
                : values.length === 1
                ? values[0].displayName
                : zpFilters[index].buttonText;
          }
        }
      });
    }
    return zpFilters;
  };

  loadOnViewEnter = async (inView) => {
    const {
      jobGroup,
      paidJobGroup,
      jobs,
      router,
      filterGroup,
      initialPayload,
      showPaidJobs,
      noNeedLoadOnViewEnter,
    } = this.props;

    const isJobGroup = !!(jobGroup || paidJobGroup);

    const filterSearchParams = JSON.parse(window.localStorage.getItem(filterSearchKey));
    let zpFilters = [...this.state.zpFilters];
    if (filterSearchParams) {
      zpFilters = this.getNewFiltersOnFilterSearchParams(mapFilterSearchParams(filterSearchParams));
    }
    this.setState(
      {
        zpFilters,
        userListingHashesFetched: true,
      },
      () => {
        if (
          inView &&
          (!jobs.length || filterSearchParams || isQueryParams(router?.query) || showPaidJobs)
        ) {
          if (noNeedLoadOnViewEnter) return;
          window.localStorage.removeItem(filterSearchKey);
          if (isJobGroup && !filterGroup) {
            this.handleFilterApply({}, true);
          } else if (filterSearchParams) {
            this.handleFilterApply(
              {
                ...mapFilterValues(this.props.filterQueue[this.props.filterQueueLength - 1]),
                ...mapFilterValues(mapFilterSearchParams(filterSearchParams)),
              },
              true,
              {},
              !!filterSearchParams
            );
          } else if (!jobs.length) {
            if (this.props.filterQueue && this.props.filterQueueLength > 0) {
              this.handleFilterApply(
                mapFilterValues(this.props.filterQueue[this.props.filterQueueLength - 1]),
                true
              );
            } else if (isJobGroup && !zpFilters.length) {
              this.handleFilterApply(initialPayload, true);
            }
          } else if (isQueryParams(router?.query) || showPaidJobs) {
            this.handleFilterApply(
              mapFilterValues(this.props.filterQueue[this.props.filterQueueLength - 1]),
              true,
              {},
              false,
              !!jobs.length
            );
          }
        }
      }
    );
  };

  /**
   * detail = { filterGroup: string, companyId: number[] }
   */
  updateFilterOnChangeOfExternalFilter = ({ detail }) => {
    const {
      loading,
      jobType,
      jobGroup,
      dispatchUserJobs,
      dispatchGetPaidJobs,
      dispatchGetCompanyJobs,
      filterQueue,
      paidJobGroup,
      showPaidJobs,
    } = this.props;

    const { initialPayload } = this.state;

    let filterDetail = {};

    if (detail.filterDetail) {
      filterDetail = detail.filterDetail;
    } else if (filterQueue) {
      filterDetail = filterQueue[filterQueue.length - 1];
    }

    if (initialPayload.remoteCategories && !filterDetail.remoteCategories) {
      delete initialPayload.remoteCategories;
    }

    const { jobGroup: filterDetailJobGroup, ...newDetail } = detail;

    if (jobGroup === filterDetailJobGroup && !loading) {
      if (detail.companyId) {
        filterDetail.companyId = detail.companyId;
      }

      this.setState(
        {
          visited: true,
          showLoading: false,
        },
        () => {
          if (jobType === 'user') {
            if (detail.showPaidJobs || showPaidJobs) {
              dispatchGetPaidJobs({
                key: paidJobGroup,
                detail: {
                  refreshJobs: true,
                  ...detail.paidJobPayload,
                  ..._pick(filterDetail, [
                    'salary',
                    'jobType',
                    'locations',
                    'jobLevels',
                    'radiusCategory',
                    'postingDateRange',
                    'dismissedListingHashes',
                  ]),
                },
                hideOnEmpty: true,
              });
            }
            const newDetails = {
              ...initialPayload,
              ...filterDetail,
              ...(detail.filterDetail || {}),
              bucketToFetch: detail.bucketToFetch,
            };
            dispatchUserJobs({
              key: jobGroup,
              detail: newDetails,
            });
          } else {
            const newDetails = {
              ...filterDetail,
              ...newDetail,
            };
            dispatchGetCompanyJobs({
              key: jobGroup,
              detail: newDetails,
              hideOnEmpty: true,
              initial: initialPayload,
            });
          }
        }
      );
    }
  };

  getUserLocations = () => {
    const locations = [];

    const { criteria, userLocation } = this.props;

    if (userLocation && userLocation.length) {
      userLocation.forEach(({ city, state }) => {
        locations.push(
          city ? { city, state: getStateAbbr(state) } : { state: getStateAbbr(state) }
        );
      });
    } else if (criteria && criteria.geoCity && criteria.geoStateCode) {
      locations.push({ city: criteria.geoCity, state: criteria.geoStateCode });
    }

    return locations;
  };

  getNewInitialPayload = (initialPayload, filterValues) => {
    const userLocation = this.getUserLocations();

    const { filterGroup, jobGroup } = this.props;

    let newInitialPayload = { ...initialPayload };

    if (
      !filterValues.remoteCategories &&
      filterGroup &&
      !(filterValues.locations && filterValues.locations.length)
    ) {
      // Use locationSort for only Company Pages (CPP, Company Jobs, Company Salary, Company Locations)
      if (newInitialPayload.companyId) {
        newInitialPayload = {
          ...newInitialPayload,
          locationSort: true,
        };
      }

      if (userLocation && userLocation.length) {
        newInitialPayload = {
          ...newInitialPayload,
          ...(newInitialPayload.companyId ? { locations: userLocation } : {}),
        };
      }
    }

    if (jobGroup === 'recentJobTitleJobBucket') {
      newInitialPayload = {
        ...newInitialPayload,
        locations: userLocation,
      };
    }

    return newInitialPayload;
  };

  getJobsPerPage = () => {
    const { jobsPerPage, ignoreDismissed } = this.props;
    const visibleJobs = this.bucketListRef?.current?.children?.length || 0;
    const extraJobs = 4 - (visibleJobs % 4 || 0);

    return ignoreDismissed ? jobsPerPage  : (jobsPerPage + (extraJobs === 4 ? 0 : extraJobs));
  }

  getMoreJobs = () => {
    const {
      dispatchGetCompanyJobsMore,
      dispatchUserJobsMore,
      loading,
      error,
      jobGroup,
      jobType,
      initialPayload,
      filterQueue,
      dispatchGetPaidJobs,
      paidJobAPIPayload,
      showPaidJobs,
      afterEveryX,
      paidJobGroup,
      paidJobs,
      onShowMoreJobs,
    } = this.props;

    const jobsPerPage = this.getJobsPerPage();
    if (onShowMoreJobs) return onShowMoreJobs();

    let filterDetail = {};

    const numPaidJobs = paidJobs?.jobs?.length ? getNumPaidJobs(jobsPerPage, afterEveryX, 4) : 0;

    if (filterQueue) {
      const filterQueueValues = filterQueue[filterQueue.length - 1];
      filterDetail = mapFilterValues(filterQueueValues, initialPayload);
    }

    const newInitialPayload = this.getNewInitialPayload(initialPayload, filterDetail);

    if (!(loading || error) && !this.hasNoMoreJobs()) {
      this.setState({ showLoading: false });
      if (jobType === 'user') {
        if (showPaidJobs) {
          dispatchGetPaidJobs({
            key: paidJobGroup,
            detail: paidJobAPIPayload,
            hideOnEmpty: true,
            showMore: true,
          });
        }
        dispatchUserJobsMore({
          key: jobGroup,
          detail: {
            ...newInitialPayload,
            ...filterDetail,
            numJobs: showPaidJobs ? jobsPerPage - numPaidJobs : jobsPerPage,
          },
          hideOnEmpty: false,
        });
      } else {
        if (showPaidJobs && validatePaidJobsPayload(paidJobAPIPayload, filterDetail)) {
          dispatchGetPaidJobs({
            key: paidJobGroup,
            detail: {
              ...mapPaidJobFilters(filterDetail, paidJobAPIPayload),
              ...addRemoteFilterToPaidJobs(filterQueue),
            },
            showMore: true,
            hideOnEmpty: true,
          });
          dispatchGetCompanyJobsMore({
            key: jobGroup,
            detail: {
              ...newInitialPayload,
              ...filterDetail,
              numJobs: showPaidJobs ? jobsPerPage - numPaidJobs : jobsPerPage,
            },
            hideOnEmpty: false,
          });
        } else {
          dispatchGetCompanyJobsMore({
            key: jobGroup,
            detail: {
              ...newInitialPayload,
              ...filterDetail,
              ...(newInitialPayload.numJobs ? { numJobs: jobsPerPage } : {}),
            },
            hideOnEmpty: false,
          });
        }
      }
    }
  };

  /**
   * move X number of card on more based on the floor value of displayed card
   */
  showMore = () => {
    const { jobsPerSlide } = this.props
    const cardWidth = CARD_WIDTH;
    const { width } = this.bucketListRef.current.getBoundingClientRect();
    const moveCard = Math.floor(width / cardWidth);
    if (moveCard >= jobsPerSlide) {
      this.scrollTo(jobsPerSlide);
    } else {
      this.scrollTo(moveCard);
    }
  };

  logEvent = () => {
    const { title } = this.props;
    const eventName = EVENTS.bucketScrolled;
    const eventLabel = `${title} - Scrolled`;
    logCustomGTMEvent(eventName, eventLabel);
  };

  updateLocationRating = (locations) => {
    locations.forEach((item) => {
      if (item?.city || item?.state) {
        updateUserRating({
          city: item.city,
          stateAbbr: getStateAbbr(item.state),
          state: getStateName(item.state),
        });
      }
    });
  };

  updateTitleRating = (title) => {
    if (title && typeof title === 'string') {
      updateUserRating({
        title,
      });
    }
  };

  handleFilterApply = (
    filters,
    hideOnEmpty = false,
    unmappedFilters = {},
    filterQuery = false,
    initialJobs = false
  ) => {
    const {
      jobType,
      jobGroup,
      initialPayload,
      filterCallback,
      followerJobGroup,
      similarJobs,
      displaySeeMore,
      dispatchGetCompanyJobs,
      dispatchGetPaidJobs,
      paidJobAPIPayload,
      showPaidJobs,
      jobsPerPage,
      afterEveryX,
      filterQueue,
      paidJobGroup,
      useOnlyPaidJobs,
    } = this.props;

    const newInitialPayload = this.getNewInitialPayload(initialPayload, filters);

    const numPaidJobs = getNumPaidJobs(jobsPerPage, afterEveryX, 4);

    if (jobType === 'user') {
      sessionStorage.setItem('userPreference', JSON.stringify(filters));
    }
    // scroll bucket to start position
    this.bucketListRef?.current?.scrollTo(0, 0);

    this.setState(
      {
        showLoading: false,
        bucketScroll: 0,
        showPrev: false,
        showNext: false,
      },
      () => {
        if (jobType === 'user') {
          filterCallback && filterCallback(filters);
        } else {
          if (
            (showPaidJobs && !filterQuery && validatePaidJobsPayload(paidJobAPIPayload, filters)) ||
            useOnlyPaidJobs
          ) {
            if (displaySeeMore && !hideOnEmpty && !_isEmpty(unmappedFilters)) {
              window.localStorage.setItem(filterSearchKey, JSON.stringify(unmappedFilters));
            }
            dispatchGetPaidJobs({
              key: paidJobGroup,
              detail: {
                ...mapPaidJobFilters(filters, paidJobAPIPayload),
                ...addRemoteFilterToPaidJobs(filterQueue),
              },
              hideOnEmpty: true,
            });
            const newDetails = {
              ...newInitialPayload,
              ...filters,
              numJobs: jobsPerPage - numPaidJobs,
            };
            if (!useOnlyPaidJobs && !initialJobs) {
              dispatchGetCompanyJobs({
                key: jobGroup,
                detail: newDetails,
                hideOnEmpty,
              });
            }
          } else {
            let newFilters = { ...filters };
            if (jobGroup === JOB_BUCKET_GROUP.CPP_FALLBACK_TO_PAID_JOBS) {
              const validPaidJobsZpFilters = ['locations', 'postingDateRange'];
              Object.keys(newFilters).forEach((filterKey) => {
                if (!validPaidJobsZpFilters.includes(filterKey)) {
                  delete newFilters[filterKey];
                }
              });
            }
            const newDetails = {
              ...newInitialPayload,
              ...filters,
              ...(newInitialPayload.numJobs ? { numJobs: jobsPerPage } : {}),
            };
            dispatchGetCompanyJobs({
              key: jobGroup,
              detail: newDetails,
              hideOnEmpty,
            });
          }
          if (followerJobGroup) {
            let followerFilter = {
              ...newInitialPayload,
              ...filters,
            };

            if (similarJobs) {
              followerFilter = {
                ...followerFilter,
                numJobs: 8,
                companyId: similarJobs.filterDetail.companyId,
              };
            }

            dispatchGetCompanyJobs({
              key: followerJobGroup,
              detail: followerFilter,
              hideOnEmpty,
            });
          }
          filterCallback && filterCallback(filters);
        }
      }
    );
    if (filters.locations) {
      this.updateLocationRating(filters.locations);
    }
    if (filters.jobTitle && !filters.socCode) {
      // do not track socCode category-titles
      this.updateTitleRating(filters.jobTitle);
    }
  };

  onScroll = async (cardWidth, leftOffset, isEnd) => {
    const { dispatchSessionBucketScrollSignupModal, displaySeeMore, jobsPerSlide } = this.props;

    try {
      if (isEnd && !displaySeeMore) {
        this.getMoreJobs();
      }

      this.scrollLeftToFireGTMScrollEvent += jobsPerSlide * cardWidth;
      this.logEvent();

      dispatchSessionBucketScrollSignupModal({ scrolledCardCount: leftOffset / cardWidth });
    } catch (e) {
      console.error(e);
    }
  };

  undoFilter = () => {
    const { filterGroup, dispatchUpdateFiltersState } = this.props;

    dispatchUpdateFiltersState({
      filterGroup,
      operation: STATE_HISTORY_OPERATIONS.UNDO,
    });
  };

  resetFilter = () => {
    const { filterGroup, dispatchUpdateFiltersState } = this.props;

    dispatchUpdateFiltersState({
      filterGroup,
      operation: STATE_HISTORY_OPERATIONS.RESET,
    });
  };

  updateProfilePreference = () => {
    window.location.href = '/profile/';
  };

  handleNetflixShowMoreClick = () => {
    const { user, dispatchSessionShowMoreSignupModal, dispatchTriggerJobAlert } = this.props;
    this.getMoreJobs();
    dispatchSessionShowMoreSignupModal();
    if (!user?.isLoggedIn) dispatchTriggerJobAlert();
  };

  getNoResultsContainer = () => {
    const {
      jobGroup,
      criteria,
      errorMessage,
      filterGroup,
      filterQueue,
      resetPreference,
      updatePreference,
    } = this.props;

    let result = (
      <NoJob
        errorMessage={errorMessage}
        showUndoButton={!!filterGroup && !!filterQueue.length && resetPreference}
        showResetButton={!!filterGroup && !!filterQueue.length && resetPreference}
        updatePreference={updatePreference}
        undoFilter={this.undoFilter}
        resetFilter={this.resetFilter}
        updateProfile={this.updateProfilePreference}
      />
    );

    if (
      jobGroup === JOB_BUCKET_GROUP.CPP_COMPANY_JOBS_BUCKET ||
      jobGroup === JOB_BUCKET_GROUP.COMPANY_SALARY_JOBS_BUCKET ||
      jobGroup === JOB_BUCKET_GROUP.COMPANY_JOBS_PAGE
    ) {
      result = <CompanyJobAlerts criteria={criteria} />;
    }

    return result;
  };

  checkJobsDismissed = () => {
    const { dismissedCount, jobs, loading } = this.props;

    return dismissedCount > 0 && jobs.length === dismissedCount && !loading && this.hasNoMoreJobs();
  };

  scrollTo = (noOfCards) => {
    const { displaySeeMore, totalJobs, layout, loading, showPaidJobs, useOnlyPaidJobs, paidJobs } = this.props;
    const { bucketScroll } = this.state;

    const paidJobsLoading = !!((showPaidJobs || useOnlyPaidJobs) && paidJobs?.loading);
    const isLoading = loading || paidJobsLoading;

    if (layout === layoutType.netflix || isLoading) return;

    const spaceBetweenCards = 18; // px
    const listItemElem = this.bucketListRef.current.children;
    const len = listItemElem?.length || 0;
    const cardWidth = CARD_WIDTH + spaceBetweenCards;

    let moveOffset = noOfCards * cardWidth;

    const maxScroll = len * cardWidth - moveOffset;

    /* calculate max limit of cards to be slide, because, for example what if you want to slide 4 cards and device width near is able to show only 3.5 cards ??
        without this logic 4th card will never show. so in that case this below condition will be true and calculate new noOfCard to be slided, in our example new noOfCard will be 3. */
    if (Math.abs(moveOffset) > this.bucketListRef.current.clientWidth + spaceBetweenCards) {
      let newNoOfCard =
        Math.floor((this.bucketListRef.current.clientWidth + spaceBetweenCards) / cardWidth) || 1; // assign 1 if calculation output is 0.
      newNoOfCard *= noOfCards > 0 ? 1 : -1;
      moveOffset = newNoOfCard * cardWidth;
    }

    let showPrev = false;
    let showNext = true;
    const isEnd = bucketScroll + moveOffset >= maxScroll;

    if (isEnd) {
      moveOffset = maxScroll;
      showPrev = true;
      showNext = !displaySeeMore && totalJobs > 20;
    } else if (bucketScroll + moveOffset <= 0) {
      moveOffset = 0;
      showPrev = false;
      showNext = true;
    } else {
      moveOffset += bucketScroll;
      showPrev = true;
      showNext = true;
    }

    this.onScroll(cardWidth, moveOffset, isEnd);

    this.setState({ bucketScroll: moveOffset, showPrev, showNext });
  };

  render() {
    const {
      loading,
      title,
      layout,
      filterGroup,
      totalJobs,
      bucketContainerClass,
      jobGroup,
      headerClass,
      isRemote,
      swapFilters,
      noTitle,
      emptyBuckets,
      isHidden,
      isPheading,
      displaySeeMore,
      isCityPage,
      ignoreDismissed,
      disableDismiss,
      countOfH2Cards,
      jobsPerPage,
      jobsPage,
      customJobCard,
      isDesktop,
      expiredJobOnExternal,
      singleCompactFilter,
      logJobCardClickEvent,
      jobsDescription,
      filterDetail,
      withCreateAlert,
      paidJobs,
      showPaidJobs,
      isH3Title,
      customTitleTag,
      afterEveryX,
      paidJobAPIPayload,
      hideMoreBtn,
      useOnlyPaidJobs,
      paidJobGroup,
      noBottomSpacing,
      pageNo,
      jobsPerSlide,
    } = this.props;

    const total = (totalJobs || 0) + (paidJobs?.totalJobs || 0);

    let { jobs = [] } = this.props;
    if (!jobGroup && !paidJobGroup) {
      console.error('jobgroup is reqired for job Container !!!!');
      return null;
    }
    if (displaySeeMore || customJobCard) {
      jobs = jobs.slice(0, 10);
    }

    const {
      showNext,
      showPrev,
      showNoJobs,
      showRemote,
      loadWithRemote,
      jobSearched,
      zpFilters,
      bucketScroll,
    } = this.state;

    let heading =
      (isRemote || isCityPage) && !noTitle ? (
        <h1
          className={`bucketListHeader brandonH2 z-mb-48 ${headerClass} ${
            filterGroup ? 'titleFilterMargin' : ''
          }`}
        >
          {title}
        </h1>
      ) : (
        !noTitle && (
          <h2
            className={`bucketListHeader brandonH2 z-mb-48 ${headerClass} ${
              filterGroup && !jobsDescription ? 'titleFilterMargin' : ''
            }`}
          >
            {title}
          </h2>
        )
      );

    if (isH3Title) {
      heading = (
        <h3
          className={`bucketListHeader zp-title-h3 text-capitalize ${headerClass} ${
            filterGroup && !jobsDescription ? 'titleFilterMargin' : ''
          }`}
        >
          {title}
        </h3>
      );
    }

    const pheading = !noTitle && (
      <p className={`bucketListHeader brandonH2 ${headerClass}`}>{title}</p>
    );
    const filterGroupHtml = filterGroup && !!zpFilters.length && (
      <div
        className={classNames(jobContainerClasses['job-container-filter'], 'job-container-filter')}
      >
        {this.props.children}
        <FilterCarousel
          singleCompactFilter={singleCompactFilter}
          filterGroup={filterGroup}
          filters={zpFilters}
        />
        {jobs.length !== 0 && showNext && !hideMoreBtn && (
          <div className={classNames(jobContainerClasses.actions, 'd-none d-lg-block')}>
            <a className="showMore" onClick={this.showMore}>
              More
            </a>
          </div>
        )}
      </div>
    );

    const jobsDescriptionHtml = jobsDescription && (
      <div className="jobs-container-description">{jobsDescription}</div>
    );

    const renderJobCard = (job, index) => {
      const customTag =
        customTitleTag?.tag &&
        customTitleTag?.numberOfJobsCards &&
        index <= customTitleTag?.numberOfJobsCards - 1
          ? customTitleTag?.tag
          : null;

      return (
        <JobCard
          job={job}
          jobs={jobs}
          containerTitle={title}
          isRemote={showRemote || loadWithRemote}
          // either show skills or job description for the job
          companySkills={!job?.jobDescription}
          ignoreDismissed={ignoreDismissed}
          disableDismiss={disableDismiss}
          jobsPage={jobsPage}
          isH2={index < countOfH2Cards} // either show skills or job description for the job
          jobSearched={jobSearched}
          isDesktop={isDesktop}
          logJobCardClickEvent={logJobCardClickEvent}
          titleTag={customTag}
          expiredJobOnExternal={expiredJobOnExternal}
          jobGroup={jobGroup}
        />
      );
    };

    const paidJobsLoading = !!((showPaidJobs || useOnlyPaidJobs) && paidJobs?.loading);

    if (showPaidJobs || useOnlyPaidJobs) {
      jobs = paginatePaidJobs(
        jobs,
        paidJobs?.jobs,
        jobsPerPage,
        paidJobAPIPayload.numJobs,
        afterEveryX
      );
    }

    return (
      <InView
        as="div"
        onChange={this.loadOnViewEnter}
        className={`${jobContainerClasses.outerContainerWrapper} ${bucketContainerClass || 'bucketContainer'} ${layout}  ${
          isHidden ? 'invisible' : ''
        }`}
        triggerOnce
      >
        <React.Fragment>
          {swapFilters ? (
            <>
              {filterGroupHtml}
              {pheading}
            </>
          ) : (
            <>
              {isPheading ? pheading : heading}
              {jobsDescriptionHtml}
              {filterGroupHtml}
            </>
          )}
          {withCreateAlert && <JobBucketAlerts type="button" filterDetail={filterDetail} />}
          {(pageNo > -1 &&
            jobs.length === 0 &&
            loading === false &&
            !paidJobsLoading &&
            !emptyBuckets) ||
          this.checkJobsDismissed() ? (
            this.getNoResultsContainer()
          ) : (
            <div
              className={classNames(
                bucketClasses.bucketContainer,
                'jobsBucketContaier',
                {
                'z-mb-0': noBottomSpacing,
              })}
            >
              <div
                className={
                  layout !== layoutType.netflix
                    ? classNames(jobContainerClasses.carouselContainer, 'carouselContainer', {
                        'z-mb-0': noBottomSpacing,
                      })
                    : ''
                }
              >
                <Swipe
                  className={classNames(jobContainerClasses['swipe-container'], {
                    'position-relative': layout !== layoutType.netflix,
                  })}
                  onSwipedLeft={() => this.scrollTo(1)}
                  onSwipedRight={() => this.scrollTo(-1)}
                >
                  <div
                    className={classNames(jobContainerClasses.bucketList,'z-pb-30', 'bucketList', {
                      netflix: layout === layoutType.netflix,
                      [jobContainerClasses.netflix]: layout === layoutType.netflix,
                    })}
                    ref={this.bucketListRef}
                    style={{ transform: `translateX(${-bucketScroll}px)`, transition: 'transform 600ms ease-in-out' }}
                  >
                    {jobs.length === 0 && !showNoJobs && loading === false && <JobCardLoader />}

                    {((jobs.length === 0 && loading && !emptyBuckets) || paidJobsLoading) && (
                      <JobCardLoader />
                    )}

                    {/* New: jobs list with "Share Zippia" Job Cardafter first 30 job cards in job bucket */}
                    {jobs.map((job, index) => {
                      if (index === 30 && layout === layoutType.bucket) {
                        return (
                          <React.Fragment key={job.listingHash + index}>
                            <ShareZippiaJobCard />
                            {renderJobCard(job, index)}
                          </React.Fragment>
                        );
                      }
                      return (
                        <React.Fragment key={job.listingHash + index}>
                          {withCreateAlert && index === 27 && layout === layoutType.netflix ? (
                            <JobBucketAlerts type="jobCard" filterDetail={filterDetail} />
                          ) : (
                            renderJobCard(job, index)
                          )}
                        </React.Fragment>
                      );
                    })}

                    {/* jobs additional loader on showMore or fetching new */}
                    {((jobs.length !== 0 && loading) || paidJobsLoading) && <JobCardLoader />}

                    {jobs.length >= 10 && !loading && displaySeeMore && !!total && !customJobCard && (
                      <div
                        className={classNames(
                          jobContainerClasses.bucketListItem,
                          'bucketSeeMore d-flex flex-column align-items-center'
                        )}
                      >
                        <div
                          onClick={() => openInCurrentTab(displaySeeMore, '_self')}
                          className={classNames('owl-next', jobContainerClasses.owlNext)}
                        />
                        <a href={displaySeeMore} className="mt-4">
                          <p>{`${formatNumber(total)} More Jobs`}</p>
                        </a>
                      </div>
                    )}

                    {customJobCard}
                  </div>
                </Swipe>

                {/* prev and next icon for only bucket view */}
                {jobs.length !== 0 && jobs.length > jobsPerSlide && layout === layoutType.bucket ? (
                  <React.Fragment>
                    <div
                      className={classNames('owl-prev', jobContainerClasses.arrow, {
                        [jobContainerClasses.hideArrow]: !showPrev,
                      })}
                      onClick={() => this.scrollTo(-jobsPerSlide)}
                    />
                    <div
                      className={classNames('owl-next', jobContainerClasses.arrow, {
                        [jobContainerClasses.hideArrow]: !showNext,
                      })}
                      onClick={() => this.scrollTo(jobsPerSlide)}
                    />
                  </React.Fragment>
                ) : (
                  jobs.length !== 0 &&
                  !displaySeeMore &&
                  layout === layoutType.netflix &&
                  totalJobs - jobsPerPage > 0 &&
                  totalJobs !== 0 && (
                    <React.Fragment>
                      <div className="d-flex justify-content-center show-more-button">
                        <ZpButton
                          theme="primary"
                          size="big"
                          onClick={this.handleNetflixShowMoreClick}
                        >
                          Show More
                        </ZpButton>
                      </div>
                    </React.Fragment>
                  )
                )}
              </div>
            </div>
          )}
        </React.Fragment>
      </InView>
    );
  }
}

const mapDispatchToProps = {
  dispatchGetCompanyJobs,
  dispatchGetCompanyJobsMore,
  dispatchUserJobs,
  dispatchUserJobsMore,
  dispatchSessionBucketScrollSignupModal,
  dispatchSessionShowMoreSignupModal,
  dispatchUpdateFiltersState: updateFiltersState,
  dispatchGetPaidJobs: getPaidJobs,
  dispatchTriggerJobAlert: showJobAlertPopup,
};

// added jobsCardDetails dynamically from job reducer
const mapStateToProps = ({ jobs, user, searchFilter, locals }, ownProps) => {
  const locationFilter = searchFilter.filters.find((item) => item.id === 'locationName');
  let returnObj = { user };

  if (locationFilter) {
    const remoteFilter = locationFilter.items.find((item) =>
      isValidExtendedLocation(item.displayName)
    );

    const isRemoteFilter = remoteFilter ? remoteFilter.enabled : false;

    if (remoteFilter) {
      returnObj = { ...returnObj, isRemoteFilter };
    }
  }

  const jobsDetails = ownProps.jobGroup ? jobs[ownProps.jobGroup] : {};
  const similarJobs = jobs[ownProps.followerJobGroup];
  const paidJobs = jobs[ownProps.paidJobGroup || JOB_BUCKET_GROUP.PAID_JOBS] || {};
  const dismissedJobs = jobs['dismissedJobs'] || [];

  const filterQueue = searchFilter.stateHistory[ownProps.filterGroup] || [];

  const filterQueueLength = searchFilter.stateHistory[ownProps.filterGroup]
    ? searchFilter.stateHistory[ownProps.filterGroup].length
    : 0;

  if (!_isEmpty(similarJobs)) {
    returnObj.similarJobs = similarJobs;
  }

  if (jobsDetails?.jobs || paidJobs?.jobs) {
    const dismissedCount = dismissedJobs.length
      ? jobsDetails?.jobs?.filter(({ listingHash }) => dismissedJobs.includes(listingHash)).length
      : 0;

    return {
      ...jobsDetails,
      ...returnObj,
      dismissedCount,
      paidJobs,
      filterQueue,
      filterQueueLength,
      showPaidJobs: !!(ownProps.enablePaidFixedPos && !locals.displayPaidJobs.hideOnFixedPos),
    };
  }
  console.info(`no bucket found inside the job reducer jobs[${ownProps.jobGroup}]`);
  return {
    ...returnObj,
    filterQueue,
    filterQueueLength,
  };
};

export const JobContainerComponent = JobContainer;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobContainer));
